var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    id: "Filled_Outline",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,19c-2.76,0-5-2.24-5-5s2.24-5,5-5c0-4.42,3.58-8,8-8c3.75,0,6.89,2.57,7.76,6.05    C24.71,7.42,27,9.95,27,13c0,3.31-2.69,6-6,6H6z",
    fill: "#C9F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,21c-2.21,0-4-1.79-4-4s1.79-4,4-4c0-3.31,2.69-6,6-6c2.63,0,4.87,1.7,5.67,4.05    C29.11,11.37,31,13.47,31,16c0,2.76-2.24,5-5,5H15z",
    fill: "#C9F9FB"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 7,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 7,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 15,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 11,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 7,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 11,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 15,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 23,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 19,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 19,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 23,
    y: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.399,10.168c-0.895-2.038-2.712-3.491-4.852-3.977C21.347,2.516,17.921,0,14,0    C9.35,0,5.512,3.546,5.047,8.075C2.19,8.533,0,11.016,0,14c0,3.309,2.691,6,6,6h5.026c0.914,1.207,2.348,2,3.974,2h4v-2h-4    c-1.654,0-3-1.346-3-3s1.346-3,3-3c0.553,0,1-0.447,1-1c0-2.757,2.243-5,5-5c2.139,0,4.037,1.355,4.724,3.372    c0.122,0.36,0.438,0.62,0.816,0.669C28.513,12.3,30,14.002,30,16c0,2.206-1.794,4-4,4h-1v2h1c3.309,0,6-2.691,6-6    C32,13.207,30.061,10.8,27.399,10.168z M14.059,12.089C11.75,12.53,10,14.564,10,17c0,0.342,0.035,0.677,0.101,1H6    c-2.206,0-4-1.794-4-4s1.794-4,4-4c0.553,0,1-0.447,1-1c0-3.859,3.141-7,7-7c2.762,0,5.2,1.609,6.332,4.032    C17.086,6.341,14.478,8.876,14.059,12.089z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 21,
    y: 20
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.dc6e6468df26353ad14e88077ebc2ab3.svg";
export { ForwardRef as ReactComponent };